import { TipoGPSEnum } from "./rota-vo";

export interface ParametrosVo {
  alertaDeProximidade: number;
  alertaMinimo: number;
  arquivosDeTerceiros: boolean;
  distanciaMinimaRetroalimentacao: number;
  enviarEmailClientes: boolean;
  permiteAtualizarStatusAtendimento: boolean;
  enviarEmailMotorista: boolean;
  finalizarRotaCancelaVisita: boolean;
  incluirAuto: boolean;
  incluirNovosAuto: boolean;
  limiteAtraso: number;
  limiteEsperaLockRotaEmSegundos: number;
  limiteTempoParado: number;
  notificaViaIntegration: boolean;
  notificacoesPermitidasIntegration: ModificacoesEnum[];
  desativarDirections: boolean;
  permissaoUsarOffLine: boolean;
  permiteAdiarVisitas: boolean;
  permiteRetroalimentacao: boolean;
  permitirControleSMS: boolean;
  podeEscolherProxVisita: boolean;
  raioAtendimento: number;
  removerAuto: boolean;
  reordenarAuto: boolean;
  smsAtrasoMinimo: number;
  smsPedidoACaminho: boolean;
  smsPedidoChegando: boolean;
  smsPedidoEmAtraso: boolean;
  smsPedidoEmRota: boolean;
  smsPedidoRemovido: boolean;
  smsProblema: boolean;
  smsPedidoRealizado?: boolean;
  smsApresentaNomeEmpresa?: boolean;
  smsApresentaNomeMotorista?: boolean;
  smsApresentaPlacaVeiculo?: boolean;
  smsApresentaContatoEmpresa?: boolean;
  smsContatoEmpresa?: string;
  smsApresentaContatoFeedback?: boolean;
  smsContatoFeedback?: string;
  ativaConfirmacaoCarregamento: boolean;

  kmMaximaDaRota?: number;
  raioMaximoCD?: number;
  raioMaximoCDIgnoraMandatorio?: boolean;

  ativaAtendimentoAPIExterna: boolean;
  nomeAppAtendimento?: string;
  packageAppAtendimento?: string;
  paramsAppAtendimento?: { [key: string]: ParamAppAtendimento };
  tipoIntegracaoAtendimento?: TipoIntegracaoAtendimento;

  permiteApresentarRoteiro?: boolean;

  limiteEsperaInsercao?: number;

  permiteGerarRota?: boolean;

  gerarRotaComPlanejamento?: boolean;

  ativaPrestacaoContas?: boolean;

  controleAutenticacao?: ControleAutenticacao;

  ativaReprogramacao?: boolean;

  limiteDiasReprogramacao?: number;

  tiposReprogramacao?: TiposReprogramacao[];

  limiteDiasExtensaoPernoite?: number;

  limiteTempoJornada?: number;

  alertaMinimoMotorista?: number;
  ocultarCampos?: CampoOcultado[];

  permissaoIncluirSemTrajeto?: boolean;

  ativaIncluirSemValidacoes?: boolean;

  regraIncluirSemValidacoes?: TiposValidacao;

  incluirIgnoraValidacoes?: TiposRazaoDeQuebra[];

  permiteReprocessarRota?: boolean;

  utilizaRastreamentoTerceiros: boolean;
  calculoKmExecutado?: TipoCalculoRastreamentoEnum;
  tiposRastreamentoPermitidos?: TipoGPSEnum[];

  nomeEmpresa?: string;

  codigoConfiguracao?: string;

  pathLogo?: string;

  linkLogo?: string;
  ativaTratativasIncidentes: boolean;

  permiteAguacao?: boolean;

  permiteDeposito?: boolean;
}

export const emptyParametros = (): ParametrosVo => ({
  arquivosDeTerceiros: false,
  ativaTratativasIncidentes: false,
  limiteEsperaLockRotaEmSegundos: 0,
  limiteTempoParado: 0,
  alertaDeProximidade: 0,
  alertaMinimo: 0,
  incluirAuto: false,
  incluirNovosAuto: false,
  reordenarAuto: false,
  limiteAtraso: 0,
  podeEscolherProxVisita: false,
  permiteAdiarVisitas: false,
  permiteReprocessarRota: false,
  permissaoUsarOffLine: false,
  removerAuto: false,
  permiteRetroalimentacao: false,
  distanciaMinimaRetroalimentacao: 0,
  raioAtendimento: 0,
  smsPedidoEmRota: false,
  smsPedidoRemovido: false,
  smsPedidoACaminho: false,
  smsPedidoChegando: false,
  smsPedidoEmAtraso: false,
  smsProblema: false,
  smsAtrasoMinimo: 0,
  smsPedidoRealizado: false,
  smsApresentaNomeEmpresa: false,
  smsApresentaPlacaVeiculo: false,
  smsApresentaNomeMotorista: false,
  smsApresentaContatoEmpresa: false,
  smsContatoEmpresa: '',
  smsApresentaContatoFeedback: false,
  smsContatoFeedback: '',
  permitirControleSMS: false,
  enviarEmailClientes: false,
  permiteAtualizarStatusAtendimento: false,
  enviarEmailMotorista: false,
  desativarDirections: false,
  notificaViaIntegration: false,
  notificacoesPermitidasIntegration: [],
  finalizarRotaCancelaVisita: false,
  ativaConfirmacaoCarregamento: false,
  ativaAtendimentoAPIExterna: false,
  permiteGerarRota: false,
  ativaPrestacaoContas: false,
  ativaReprogramacao: false,
  limiteDiasReprogramacao: 0,
  tiposReprogramacao: [],
  limiteDiasExtensaoPernoite: 0,
  limiteTempoJornada: 0,
  alertaMinimoMotorista: 0,
  ocultarCampos: [],
  utilizaRastreamentoTerceiros: false,
  permissaoIncluirSemTrajeto: false,
  ativaIncluirSemValidacoes: false,
  incluirIgnoraValidacoes: [],
  linkLogo: '',
  permiteAguacao: false,
  permiteDeposito: false,
});

export type TiposValidacao = 'APENAS_COLETA' | 'APENAS_ENTREGAS' | 'QUALQUER_PEDIDO';
export const TIPOS_VALIDACAO: TiposValidacao[] = ['APENAS_COLETA', 'APENAS_ENTREGAS', 'QUALQUER_PEDIDO'];

export type TiposRazaoDeQuebra = 'AVERAGETIMELIMIT' | 'VISITLIMIT' | 'TIMEWINDOW';
export const TIPOS_RAZAO_DE_QUEBRA: TiposRazaoDeQuebra[] = ['AVERAGETIMELIMIT', 'VISITLIMIT', 'TIMEWINDOW'];

export type TiposReprogramacao = 'NAO_ATENDIDOS' | 'PROBLEMA_AO_REALIZAR' | 'ORFAOS';
export const TIPOS_REPROGRAMACAO: TiposReprogramacao[] = ['NAO_ATENDIDOS', 'PROBLEMA_AO_REALIZAR', 'ORFAOS'];

export type ParamAppAtendimento = 'CODPOI' | 'CODSERVICO' | 'NOTAFISCAL';

export type ControleAutenticacao = 'PATHFIND' | 'CUSTOM' | 'OKTA_FEDEX';
export const CONTROLE_AUTENTICACAO_OPTIONS: ControleAutenticacao[] = ['PATHFIND', 'CUSTOM', 'OKTA_FEDEX'];
export const CONTROLE_AUTENTICACAO_PADRAO: ControleAutenticacao = 'PATHFIND';

export type CampoOcultado = 'VALOR' | 'ALTO_VALOR_AGREGADO' | 'ESCOLTA';
export const OCULTAR_CAMPOS_OPTIONS: CampoOcultado[] = ['VALOR', 'ALTO_VALOR_AGREGADO', 'ESCOLTA'];

export type TipoCalculoRastreamento = 'TERCEIROS' | 'PATHFIND';
export const TIPO_CALCULO_RASTREAMENTO: TipoCalculoRastreamento[] = ['TERCEIROS', 'PATHFIND'];

export type TipoRastreamento = 'VANGUARDA' ; // | 'PATHFIND
export const TIPO_RASTREAMENTO: TipoRastreamento[] = ['VANGUARDA']; // 'PATHFIND',

export type TipoIntegracaoAtendimento = 'SIVA_CONSIGAZ' | 'LUX_ATLANTICA';
export const TIPOS_API_INTEGRACAO: TipoIntegracaoAtendimento[] = ['SIVA_CONSIGAZ', 'LUX_ATLANTICA'];

export enum ModificacoesEnum {
  // noinspection JSUnusedGlobalSymbols
  ADIARVISITA,
  ADICAOPOIAUTOMATICA,
  ARQUIVOENVIADO,
  ARQUIVONAOENVIADO,
  ATUALIZACAOMANUALDEROTA,
  CANCELAMENTODEPOIS,
  CARREGAMENTO_ROTA,
  DESFAZERADIARVISITA,
  DISTANCIAATUALIZADA,
  DISTANTEDEMAISPARAATENDER,
  EVENTOROTA,
  FALHAAOINSERIR,
  FALHAAOTRANSFERIR,
  FINALIZACAOMANUALDEROTA,
  FINALIZANDOATENDIMENTOSERVICO,
  INSERCAODEROTA,
  NOTIFICACAOGERAL,
  NOTIFICACAO_PEDIDO_ORFAO,
  NOTIFICACAO_SMS,
  POIAGUARDAINTEGRACAO,
  POICANCELADO,
  POICHEGADA,
  POICHEGANDO,
  POIPROBLEMA,
  POIREMOVIDO,
  // POIADICIONADO,
  POISADICIONADOS,
  POISAIDA,
  POITRANSFERIDO,
  PROCESSANDO_LIBERACAO,
  REMOCAODEPOIS,
  REMOCAODEROTA,
  REMOCAOPOIAUTOMATICA,
  REORDENACAOMANUALDEROTA,
  REORDENACAOMANUALEAUTOMATICADEROTA,
  ROTAATUALIZADA,
  ROTAREORDENADA,
  ROTA_LIBERACAO_REVERTIDA,
  ROTA_LIBERADA,
  SERVICOAGUARDAINTEGRACAO,
  SERVICOALTERADO,
  SERVICOCADASTRONOTAFISCAL,
  SERVICOCUBAGEMALTERADO,
  SERVICOINICIOATENDIMENTO,
  SERVICOINSERIDO,
  SERVICOOBSAVOESALTERADAS,
  SERVICOPESOALTERADO,
  SERVICOPROBLEMA,
  SERVICOREMOVIDO,
  SERVICOVALORALTERADO,
  SERVICOVOLUMEALTERADO,
  TEMPOATUALIZADO,
  TRANSFERENCIADEPOIS,
  TRATATIVA_INCIDENTE_NECESSARIA,
  TRATATIVA_INCIDENTE_REALIZADA
}

export enum TipoCalculoRastreamentoEnum {
  TERCEIROS = "TERCEIROS",
  PATHFIND = "PATHFIND",
}
